var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useContext } from "react";
import { MonthInput } from "../shared-components/Monthinput/MonthInput";
import { YearInput } from "../shared-components/YearInput/YearInput";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import MultiSelect from "../shared-components/MultiSelect/MultiSelect";
import JesuisJechercheContext from "../../../application/Context/JesuisJechercheContext";
export var Filters = function () {
    var _a;
    var _b = useContext(JesuisJechercheContext), categories = _b.categories, selectedCategory = _b.selectedCategory, handleCategoryChange = _b.handleCategoryChange, months = _b.months, handleMonthChange = _b.handleMonthChange, handleYear = _b.handleYear, yearInput = _b.yearInput, filtersIsLoading = _b.filtersIsLoading;
    var langCode = ((_a = document.getElementById("language-code")) === null || _a === void 0 ? void 0 : _a.value) || "en";
    var t = useTranslation(["news"]).t;
    return (_jsx(React.Fragment, { children: _jsxs(motion.div, __assign({ initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.2 }, exit: { opacity: 0 } }, { children: [_jsx(MultiSelect, { title: t("Catégories"), placeHolder: t("Select one or more categories"), data: categories.map(function (e) {
                        return { id: e.value, value: e["label_".concat(langCode)] };
                    }), handleClick: handleCategoryChange, SelectedChoices: selectedCategory }), _jsxs("div", __assign({ className: "row" }, { children: [_jsx("div", __assign({ className: "col-md-8 p-0" }, { children: _jsx(MonthInput, { type: "checkbox", onChange: handleMonthChange, months: months, title: "Mois", disabled: filtersIsLoading }) })), _jsx("div", __assign({ className: "col-md-4 p-0 ps-md-1" }, { children: _jsx(YearInput, { type: "number", yearInput: yearInput, onChange: handleYear, disabled: filtersIsLoading }) }))] }))] })) }));
};
